
import React, { useState } from 'react';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import './Prawa.css';
const DAO_SKLEP_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/producent';

export default function Prawa() {
    const [producenci, setProducenci] = useState([]);
    const [producent, setProducent] = useState(getProducent());
    const [producentszukaj, setProducentSzukaj] = useState();

    const fetchSzukaj = async (producentszukaj) => {
        console.log("producentszukajproducentszukajproducentszukaj:" + producentszukaj);
        const res = await axios(DAO_SKLEP_URL, {
            method: 'POST',
            withCredentials: false,
            headers: {
                'Accept': 'application/json'
            },
            data: { operacja: "szukaj", co: producentszukaj }
        }).then((response) => {
            console.log("resp.szukaj:" + JSON.stringify(response.data));
            return response.data.producenci;
        }).catch(err => console.log(err.message));
        setProducenci(res);
    };

    const handleSubmit = async e => {
        console.log("producentszukaj:" + producentszukaj);
        e.preventDefault();
        if (producentszukaj === "") {
            return;
        } else {
            fetchSzukaj(producentszukaj);
        }
    }

    const handleClick = param => e => {
        e.preventDefault();
        console.log("clickqqq" + param);
        if (param.item.nip === "0") {
            window.location = process.env.PUBLIC_URL+"/ustawienia/" + param.item.nip;
            return;
        }
        sessionStorage.setItem('producent', JSON.stringify(param.item));
        const tokenString = sessionStorage.getItem('token');
        if (tokenString === "" || tokenString === null) {
            window.location = process.env.PUBLIC_URL+"/start";
            return;
        }
        let userToken = JSON.parse(tokenString);
        userToken.nip = param.item.nip;
        sessionStorage.setItem('token', JSON.stringify(userToken));
        window.location =process.env.PUBLIC_URL+ "/ustawienia/" + param.item.nip;
    }

    function Lista(prop) {
        if (prop.producenci && prop.producenci.length) {
            console.log("prop.producenci" + prop.producenci);
            const lista = prop.producenci.map((item, key) => {
               let snip=item.nip==="0"?"":item.nip;
                return (<><a href="#" onClick={handleClick({ item })}>{item.nazwa}</a>
                    <h6>{snip}
                        <br />{item.miejscowosc}</h6>
                    <hr /></>)
            });
            return (<>{lista}</>)
        }
        else {
            return (<></>)
        }
    }
    function Producent(prop) {
        if (prop.producent === null) {
            return (<></>);
        }
        return (<> <h6 style={{ backgroundColor: 'silver', margin: '0px' }}><a href={process.env.PUBLIC_URL+"/ustawienia/" + prop.producent.nip}>{prop.producent.nazwa}</a>
            <br />{prop.producent.nip}
            <br />{prop.producent.miejscowosc}</h6>
            <hr /></>)
    }

    return (<>
        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formBasicEmail">
                <Form.Control  autoComplete="off" className="mt-1 rounded-0 tekst" onChange={e => setProducentSzukaj(e.target.value)} size="sm" type="text" placeholder="Producent ..." />
            </Form.Group>
        </Form>
        <Producent producent={producent} />
        <Lista producenci={producenci} />
    </>);
}
function getProducent() {
    const producentString = sessionStorage.getItem('producent');
    //let producentToken = JSON.parse(producentString);
    if (producentString === null || producentString === "")
        return null;
    console.log(producentString);
    return JSON.parse(producentString)
}
